import { render, staticRenderFns } from "./SubastaForm.vue?vue&type=template&id=f538bdfe"
import script from "./SubastaForm.vue?vue&type=script&lang=js"
export * from "./SubastaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports